import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAppProperties } from "@/hooks";
import { CloseMD } from "@/icons";
import { cn, getUrlFromFilename } from "@/utils";

interface UserScreenWrapperProps {
  showCloseButton?: boolean;
  children: ReactNode;
  contentClassName?: string;
}

export const UserScreenWrapper = ({
  showCloseButton,
  children,
  contentClassName,
}: UserScreenWrapperProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { data: properties } = useAppProperties();
  const signUpImage = properties?.SignUpImageWeb;
  const signInImage = properties?.SignInImageWeb
    ? properties.SignInImageWeb
    : signUpImage; // SignInImage is optional so fall back to SignUpImage

  const backgroundImage = ["/sign-in", "/reset-password"].includes(pathname)
    ? signInImage
    : signUpImage;
  const backgroundImageUrl = backgroundImage
    ? getUrlFromFilename(backgroundImage)
    : "";

  return (
    <div className="bg-surface-primary relative grid h-full grid-cols-1 items-center lg:grid-cols-2">
      <div className="relative h-full overflow-y-hidden pt-[90px] sm:pt-0">
        <div className="flex h-full w-full flex-col items-center justify-start overflow-y-auto pt-4 sm:py-10">
          <div
            className={cn([
              "flex w-[90%] max-w-[440px] flex-col sm:my-auto sm:h-fit sm:w-2/3",
              contentClassName,
            ])}
          >
            {children}
          </div>
        </div>
      </div>
      <div
        className="bg-surface-secondary hidden h-full bg-cover bg-center lg:block"
        style={{ backgroundImage: `url('${backgroundImageUrl}')` }}
      />
      {showCloseButton && (
        <div
          onClick={() => navigate(-1)}
          className="absolute right-3 top-12 z-20 cursor-pointer rounded-full bg-white/40 p-[8px] text-black/80 sm:right-9 sm:top-9"
        >
          <CloseMD className="h-6 w-6 sm:h-7 sm:w-7" />
        </div>
      )}
    </div>
  );
};
